module.exports = __webpack_public_path__ + "img/ico_quesion.4c1cdd82.png";